import { authenticatedFetch } from '../../api/request';

export default function getUserLicenses() {
    return authenticatedFetch('/v5/userLicenses');
}
